import { render, staticRenderFns } from "./markBox.vue?vue&type=template&id=6d8dd96c&scoped=true&"
import script from "./markBox.vue?vue&type=script&lang=js&"
export * from "./markBox.vue?vue&type=script&lang=js&"
import style0 from "./markBox.vue?vue&type=style&index=0&id=6d8dd96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8dd96c",
  null
  
)

export default component.exports